<template>
  <el-dialog :visible.sync="visible" :title="'设置'" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
    </el-form>
    <el-table :data="taskList" border style="width: 100%;">
      <el-table-column width="300px" prop="medalName" label="奖章名称" header-align="center" align="center"></el-table-column>
      <el-table-column width="300px" prop="typeName" label="所属类别" header-align="center" align="center"></el-table-column>
      <el-table-column prop="imgUrl" label="图标" header-align="center" align="center">
        <template slot-scope="scope">
          <el-image  style="width: 75px; height: 75px" :src="scope.row.imgUrl" fit="cover"></el-image>
        </template>
      </el-table-column>
      <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
        <template slot-scope="scope" >
          <el-button v-if="isInArray(scope.row)" size="mini" @click="setTaskTermGrade(scope.row)">添加</el-button>
          <el-button v-else=""  type="danger" size="mini" @click="removeTaskTermGrade(scope.row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      visible: false,
      addVisible: false,
      gradeNameList: '',
      basisDecorationList: [],
      taskList: [],
      dataForm: {
        decorationId: '',
        specialName: '',
        tableId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  mounted () {
  },
  methods: {
    init () {
      this.visible = true
      this.getBasisDecorationList()
      this.getTaskList()
      this.$nextTick(() => {
        this.getTaskList()
      })
    },
    // 获取基础章列表
    getTaskList () {
      this.$http.get('decoration/decoration/getList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.taskList = res.data
        console.log(this.taskList)
      })
    },
    // 获取特色章下基础章列表
    getBasisDecorationList () {
      this.$http.get('xytsz/decorationAndBasis/getBasisDecorationList', {
        params: {
          decorationId: this.dataForm.decorationId,
          ruleConfigTableId: this.dataForm.tableId
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.basisDecorationList = res.data
      })
    },
    isInArray (row) {
      for (var i = 0; i < this.basisDecorationList.length; i++) {
        if (row.id === this.basisDecorationList[i].basisDecorationId) {
          return false
        }
      }
      return true
    },
    /**
       * 添加年级章
       */
    setTaskTermGrade: debounce(function (row) {
      console.log(row.imgUrl, '+++++++++++++++++++++')
      // 组装参数
      const params = {
        decorationId: this.dataForm.decorationId,
        specialName: this.dataForm.specialName,
        decorationLevel: this.dataForm.decorationLevel,
        ruleConfigTableId: this.dataForm.tableId,
        decorationImgUrl: this.dataForm.decorationImgUrl,
        basisDecorationImgUrl: row.imgUrl,
        basisDecorationName: row.medalName,
        basisDecorationId: row.id
      }
      this.$http.post('/xytsz/decorationAndBasis', params).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.init()
        this.$emit('refreshDataList')
        this.$notify({
          type: 'success',
          duration: '750',
          message: '奖章设置成功'
        })
      })
    }, 50, { leading: true, trailing: false }),
    removeTaskTermGrade: debounce(function (row) {
      // 组装参数
      const params = {
        decorationId: this.dataForm.decorationId,
        ruleConfigTableId: this.dataForm.tableId,
        basisDecorationId: row.id
      }
      this.$http.post('/xytsz/decorationAndBasis/removeDecoration', params).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.init()
        this.$emit('refreshDataList')
        this.$notify({
          type: 'info',
          duration: '750',
          message: '奖章移除成功'
        })
      })
    }, 50, { leading: true, trailing: false })
  }
}
</script>
